export default class BLH5Preview {
  static get EVENT_PREVIEW () {
    return 'H5_PREVIEW'
  }

  static get EVENT_NOT_SUPPORT () {
    return 'H5_PREVIEW_NOT_SUPPORT'
  }

  static error (msg) {
    if (process.env.NODE_ENV === 'development') {
      return
    }
    if (!msg || msg === null || msg === '') {
      msg = 'h5 pdf preview error!'
    }
    let errorMsg = new Error(msg)
    window.__bl && window.__bl.error(errorMsg)
  }

  static sum (event, count) {
    if (process.env.NODE_ENV === 'development') {
      return
    }
    if (!count) {
      count = 1
    }
    window.__bl && window.__bl.sum(event, count)
  }
}
